// src/components/SelectionBar.jsx
//
// Replaces the always-visible (and mostly greyed-out) icon row of the Raw requests
// tab. It exists ONLY while rows are picked: "3 selected · Download HAR · Save ·
// Run checks · Compare". Slot Story step 4, AC 3.12-3.14.
import React from 'react';

export const COMPARE_NEED_TWO = 'Pick exactly two requests';
export const COMPARE_NEED_SAME_HOST = 'Both picks must share a host';

/**
 * compareState(pickedCount, sameHost) -> { enabled, title }
 * Compare needs exactly two picks (the modal reads the first two) on one host.
 */
export function compareState(pickedCount, sameHost) {
  if (pickedCount !== 2) return { enabled: false, title: COMPARE_NEED_TWO };
  if (!sameHost) return { enabled: false, title: COMPARE_NEED_SAME_HOST };
  return { enabled: true, title: 'Compare selected requests' };
}

const BTN = {
  padding: '4px 10px', fontSize: 12, fontWeight: 500, borderRadius: 6, cursor: 'pointer',
  border: '1px solid var(--line)', background: 'var(--card)', color: 'var(--ink)', whiteSpace: 'nowrap',
};
const BTN_OFF = { opacity: 0.45, cursor: 'not-allowed' };

export default function SelectionBar({
  count, sameHost = true, onDownloadHar, onSave, onRunChecks, onCompare, onClear,
}) {
  if (!count || count < 1) return null;
  const cmp = compareState(count, sameHost);
  const plural = count > 1 ? 's' : '';
  return (
    <div
      role="toolbar"
      aria-label="Selected requests"
      data-testid="selection-bar"
      style={{
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6,
        padding: '6px 12px', borderBottom: '1px solid var(--line)', background: 'var(--surface, var(--bg))',
      }}
    >
      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink)', marginRight: 4 }}>{count} selected</span>
      <button type="button" style={BTN} onClick={onDownloadHar} title={`Download ${count} selected request${plural} as HAR`}>
        Download HAR
      </button>
      <button type="button" style={BTN} onClick={onSave} title={`Save ${count} selected request${plural} to backend`}>
        Save
      </button>
      <button type="button" style={BTN} onClick={onRunChecks} title={`Run checks on ${count} selected request${plural}`}>
        Run checks
      </button>
      <button
        type="button"
        style={{ ...BTN, ...(cmp.enabled ? {} : BTN_OFF) }}
        disabled={!cmp.enabled}
        onClick={onCompare}
        title={cmp.title}
      >
        Compare
      </button>
      <button
        type="button"
        style={{ ...BTN, marginLeft: 'auto', color: 'var(--error-text)' }}
        onClick={onClear}
        title="Clear selection"
        aria-label="Clear selection"
      >
        {'✕'}
      </button>
    </div>
  );
}
